const RegistrationSteps = {
  Registration: 'registration',
  Connect: 'connect',
  Create: 'create',
  Success: 'success',
}

export default RegistrationSteps
